import React from 'react';
import { useUpdateShape } from 'hooks';
import Collapse from './Collapse';
import DayLabelFields from './DayLabelFields';

export const DayLabelStyle = ({ shape, toolbarRef }) => {
  const onChange = useUpdateShape(shape.id);

  return (
    <Collapse text="Weekday names">
      <DayLabelFields shape={shape} onChange={onChange} toolbarRef={toolbarRef} />
    </Collapse>
  );
};

export default DayLabelStyle;
